var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#EAEDFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_312_4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0813 17.7172C12.2451 16.9809 12.6478 16.3235 13.2235 15.8527C13.7992 15.3818 14.5137 15.1254 15.25 15.1255H34.75C35.4863 15.1254 36.2008 15.3818 36.7765 15.8527C37.3522 16.3235 37.7549 16.9809 37.9187 17.7172L25 25.8155L12.0813 17.7172ZM12 19.6205V31.4605L21.4299 25.5305L12 19.6205ZM22.9866 26.5088L12.3104 33.2205C12.5742 33.791 12.9905 34.2729 13.5109 34.6101C14.0313 34.9474 14.6344 35.1261 15.25 35.1255H34.75C35.3655 35.1256 35.9684 34.9465 36.4885 34.609C37.0086 34.2714 37.4246 33.7894 37.688 33.2188L27.0118 26.5072L25 27.7688L22.9866 26.5072V26.5088ZM28.5701 25.5322L38 31.4605V19.6205L28.5701 25.5305V25.5322Z",
    fill: "#001FC5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_312_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ff077c48d32b92da101760e23a2d3a89.svg";
export { ForwardRef as ReactComponent };